import { SizeLocales } from "@lib/constants/filtersConstants";
import { siteConfig } from "./localizationConfigObject";
import type { Market, SiteConfigEntry } from "./types";

const getHostnameSiteConfig = (): SiteConfigEntry => {
    const HOSTNAME = process.env.NEXT_PUBLIC_HOSTNAME;

    if (!HOSTNAME) {
        throw new Error(`Missing env variable HOSTNAME and NEXT_PUBLIC_HOSTNAME`);
    }
    const countryCode = HOSTNAME.split(".")?.[0] as Market;

    const hostNameConfig = siteConfig?.[countryCode];
    if (!hostNameConfig) {
        throw new Error(`No Config found for hostname ${HOSTNAME}`);
    }
    return hostNameConfig;
};

export const activeSiteConfig = getHostnameSiteConfig();

export const {
    currency: activeSiteCurrency,
    country: activeSiteCountry,
    fractionDigits: activeSiteFractionDigits,
    liveChat: activeSiteHasLiveChat,
    sizeGuideCollections: activeSiteSizeGuideCollections,
} = activeSiteConfig;

export const getCountryCode = activeSiteConfig?.checkout.countryCode;
export const getCountry = activeSiteConfig?.country;

export const getOrderNumberFormatRegex = activeSiteConfig?.orderNumberFormatRegex;

export const getLanguageFromLocale = (locale: string) => {
    return locale.split("-")[0];
};

export const getCheckoutForSite = activeSiteConfig?.checkout;

export const shoeConventionForSite = activeSiteConfig.shoeSizingConventions || [
    SizeLocales.EU,
    SizeLocales.US,
];

export const reCaptchaIntegrationEnabled =
    activeSiteConfig.reCaptchaIntegration.checkout ||
    activeSiteConfig.reCaptchaIntegration.contactForm;

export const getCountryForSiteByLocale = (locale: string) => {
    return locale.split("-")[1];
};

export const getCurrencyForSiteByLocale = (locale: string) => {
    const country = locale.split("-")[1].toLowerCase() as Market;
    return siteConfig?.[country]?.currency;
};

export const trustpilotIntegrationEnabled = activeSiteConfig.trustpilotIntegration ?? false;

export const siteLanguage = activeSiteConfig.language;

export const hasExpressCheckout =
    JSON.parse(process.env.NEXT_PUBLIC_PAYMENT_ADVANCED_FLOW ?? "false") &&
    activeSiteConfig?.hasExpressCheckout;
